<template>
  <div class="no">
    <img src="@/assets/imgs/404.png" alt="" />
    <el-button type="primary" @click="$router.push('/home')"
      >返回首页</el-button
    >
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.no {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.no img {
  width: 60%;
  height: 40%;
  object-fit: contain;
}
.el-button {
  position: absolute;
  bottom: 30%;
  left: 50%;
}
</style>
